import { ActionTypes } from '../actions';

const SearchReducer = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.SEARCHBUTTON:
      return action.payload;
    default:
      return state;
  }
};

export default SearchReducer;
